import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import {PrivateLoggedRoute} from "./privateRoute/PrivateLoggedRoute";
import {PrivateRoute} from "./privateRoute/PrivateRoute";
import React from "react";
import {NotFound} from "../NotFound/NotFound";
import SignIn from "../Auth/SignIn";
import {Passport} from "../Passport/Passport";
import Recovery from "../Auth/RecoverySteps/Recovery";
import {useAppSelector} from "../../app/hooks";
import SignUp from "../Auth/SignUp";
import Welcome from "../Auth/Welcome";

interface RouterProps {
    preventRedirect: boolean
}

export const Router = ({preventRedirect}: RouterProps) => {

    const {token} = useAppSelector(state => state.auth)
    const {search} = useLocation();

    return <Routes>
        <Route path={`/welcome`} element={<PrivateLoggedRoute hasToken={(!!token && !preventRedirect)}/>}>
            <Route path={`/welcome`} element={<Welcome/>}/>
        </Route>
        <Route path={`/sign-in`} element={<PrivateLoggedRoute hasToken={(!!token && !preventRedirect)}/>}>
            <Route path={`/sign-in`} element={<SignIn/>}/>
        </Route>
        <Route path={`/sign-up`} element={<PrivateLoggedRoute hasToken={(!!token && !preventRedirect)}/>}>
            <Route path={`/sign-up`} element={<SignUp/>}/>
        </Route>
        <Route path='/password/recovery' element={<PrivateLoggedRoute hasToken={!!token}/>}>
            <Route path='/password/recovery' element={<Recovery/>}/>
        </Route>
        <Route path='/passport' element={<PrivateRoute hasToken={!!token}/>}>
            <Route path='/passport' element={<Passport/>}/>
        </Route>
        <Route
            path="/"
            element={!!token && !preventRedirect
                ? <Navigate to="/passport" replace/>
                : <Navigate to={`/sign-in${search}`} replace/>}
        />
        <Route path='*' element={<NotFound/>}/>
    </Routes>
}